"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
export function createPermit2SignatureStep(permitData, token) {
  return { type: TransactionStepType.Permit2Signature, token, ...permitData };
}
